import { UseMutationResult, useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { apiEndpoints } from 'settings/_apiSettings'
import axios from 'settings/axios'

interface UpdateReservationParams {
  uuid: string
  professionalUsername: string
  patientUsername: string
  recurrentStartDate?: string
  recurrentEndDate?: string
  nonRecurrentReservationDates?: {
    oldDate: string
    newDate: string
  }[]
}

async function handleUpdateReservation({
  uuid,
  nonRecurrentReservationDates,
  professionalUsername,
  patientUsername,
  recurrentStartDate,
  recurrentEndDate
}: UpdateReservationParams): Promise<AxiosResponse> {
  const payload = {
    professional_username: professionalUsername,
    patient_username: patientUsername,
    ...(recurrentStartDate && { recurrent_start_date: recurrentStartDate }),
    ...(recurrentEndDate && { recurrent_end_date: recurrentEndDate }),
    ...(nonRecurrentReservationDates.length && {
      non_recurrent_reservation_dates: nonRecurrentReservationDates.map(item => ({
        old_date: item.oldDate,
        new_date: item.newDate
      }))
    })
  }

  return await axios.patch(`${String(apiEndpoints.RESERVATION)}${uuid}/`, payload)
}

export const useUpdateReservation = (): UseMutationResult => {
  return useMutation<AxiosResponse, Error, UpdateReservationParams>(handleUpdateReservation)
}